<template>
    <div>
        <template v-if="position === 'calendar'">
            <div class="btn-group" v-if="active">
                <v-button
                    size="sm"
                    icon="material-icons.phone"
                    :label="__('Calling')+' '+duration"
                    color="danger"
                    data-tooltip="true" 
                    :data-original-title="__('Hang up')"
                    @onClick="hangupCall()"
                >
                </v-button>
                <div class="tooltip-content content-width center light">
                    <p>{{ __('Hang up') }}</p>
                </div>
            </div>
            <template v-else>
                <v-button
                    size="sm"
                    variant="secondary" color="white"
                    :label="__('Call via the app on your PC/phone')"
                    @onClick="makeCall()"
                    :disabled="disabled"
                >
                </v-button>

                <div class="tooltip-content content-width center light">
                    <p>{{ __('Call via the app on your PC/phone') }}</p>
                </div>
            </template>
        </template>
        <template v-else>
            <template v-if="active">
                <v-button
                    size="sm"
                    icon="material-icons.phone"
                    :label="__('Calling')+' '+duration"
                    color="danger"
                    data-tooltip="true" 
                    :data-original-title="__('Hang up')"
                    @onClick="hangupCall()"
                >
                </v-button>

                <div class="tooltip-content content-width center">
                    <p>{{ __('Hang up') }}</p>
                </div>
            </template>
            <template v-else>
                <v-button
                    size="sm"
                    icon="material-icons.phone"
                    :label="null"
                    data-tooltip="true" 
                    :data-original-title="__('Call via the app on your PC/phone')"
                    @onClick="makeCall()"
                    :disabled="disabled"
                >
                </v-button>

                <div class="tooltip-content content-width center">
                    <p>{{ __('Call via the app on your PC/phone') }}</p>
                </div>
            </template>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        coach_name: {
            type: String,
            required: true
        },
        phone_number: {
            type: String,
            required: true
        },
        position: {
            type: String,
            required: false
        },
        cloudtalk_id: {
            type: String,
            required: false,
            default: null
        }
    },
    data() {
        return {
            active: false,
            intervalFetch: null,
            intervalDuration: null,
            duration: '',
            callID: null,
            token: null,
            disabled: false
        }
    },
    mounted() {
        console.log(this.coach_name)
        console.log(this.phone_number)
    },
    methods: {        
        makeCall() {
            if(this.cloudtalk_id) {
                this.makeCloudtalkCall()
            } else {
                alert("Cloudtalk ID is missing.")
            }
        },
        makeCallDaktela() {
            var that = this

            const instance = axios.create()

            delete instance.defaults.headers.common['X-CSRF-TOKEN']
            delete instance.defaults.headers.common['X-Requested-With']

            const userData = {
                password: 'PwdVd2020',
                username: this.coach_name,
                only_token: true
            }

            instance.post('https://vitadio.daktela.com/api/v6/login.json', userData)
            .then(function (e) {
                that.token = e.data.result;

                that.callToPacient()
            })    
            .catch(function (error) {
                console.log(error);
            });

            //that.callToPacient()
        },
        callToPacient() {
            this.active = true
            var that = this

            const instance = axios.create()

            delete instance.defaults.headers.common['X-CSRF-TOKEN']
            delete instance.defaults.headers.common['X-Requested-With']

            const callData = {
                number: this.phone_number,
                user: this.coach_name,
                type: 'CALL'
            }

            instance.post('https://vitadio.daktela.com/api/v6/activities.json?accessToken='+this.token, callData)
            .then(function (e) {
                that.callID = e.data.result.name

                that.fetchCallInfo(that.callID)
            })    
            .catch(function (error) {
                console.log(error.response);
            });

            //that.fetchCallInfo(1)

            if(this.position !== 'calendar') {
                this.$el.querySelector(".tooltip").remove()
            }
        },
        closeCall() {
            this.active = false

            clearInterval(this.intervalFetch)
            clearInterval(this.intervalDuration)
            this.duration = ""
            this.callID = null
            this.token = null
        },
        fetchCallInfo(id) {
            var that = this
            var answered = true
            const instance = axios.create()

            delete instance.defaults.headers.common['X-CSRF-TOKEN']
            delete instance.defaults.headers.common['X-Requested-With']
            
            this.intervalFetch = setInterval(() => {
                instance.get('https://vitadio.daktela.com/api/v6/activities/'+id+'.json?accessToken='+this.token).then(function (e) {
                    if(e.data.result.item.answered && answered) {
                        that.getTime(moment())
                        answered = false
                    }

                    if(e.data.result.action === "CLOSE") {
                        that.closeCall()
                    }
                })   
                .catch(function (error) {
                    console.log(error.response);
                });
            }, 1000);

            //that.getTime(moment())
        },
        getTime(datetime) {
            this.duration = "00:00"

            this.intervalDuration = setInterval(() => {
                var now = moment()
                this.duration = moment(now - datetime).format("mm:ss")
            }, 1000);
        },
        hangupCall() {
            var that = this
            const instance = axios.create()

            delete instance.defaults.headers.common['X-CSRF-TOKEN']
            delete instance.defaults.headers.common['X-Requested-With']

            const callData = {
                hangup: {
                    channel: null
                }
            }

            instance.put('https://vitadio.daktela.com/api/v6/activities/'+this.callID+'.json?accessToken='+this.token, callData)
            .then(function (e) {
                that.closeCall()
            })   
            .catch(function (error) {
                console.log(error.response);
            });

            //that.closeCall()
        },
        makeCloudtalkCall() {
            var that = this
            const instance = axios.create()

            delete instance.defaults.headers.common['X-CSRF-TOKEN']
            delete instance.defaults.headers.common['X-Requested-With']

            const callData = {
                agent_id: this.cloudtalk_id,
                callee_number: this.phone_number,
            }

            instance.post('/api/cloudtalk/calls/create', callData)
            .then(function (e) {
                console.log(e.response)
                that.disableForMoment()
            })   
            .catch(function (error) {
                console.log(error.response)
            });
        },
        disableForMoment() {
            this.disabled = true

            setTimeout(() => {
                this.disabled = false
            }, 5000);
        }
    }
}
</script>
